import { render, staticRenderFns } from "./extendlist.vue?vue&type=template&id=bff2a7d6&scoped=true"
import script from "./extendlist.vue?vue&type=script&lang=js"
export * from "./extendlist.vue?vue&type=script&lang=js"
import style0 from "./extendlist.vue?vue&type=style&index=0&id=bff2a7d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff2a7d6",
  null
  
)

export default component.exports